import { css } from '@linaria/core';

export const tileLockedColor = 'rgba(55, 64, 82, 1)';

export const tileLockedStyle = css`
  background: ${tileLockedColor};
`;

const gradientMiddleLayer = `
  conic-gradient(
      from 90deg at 50% 50%,
      #8000ff 0deg,
      #ffee93 95.4deg,
      #0047ff 212.4deg,
      #ff57c6 266.4deg,
      #6100ff 320.4deg,
      #8000ff 356.4deg,
      #8000ff 360deg
    )
`;

const gradientBottomLayer = `
  linear-gradient(0deg, rgba(115, 162, 255, 1), rgba(115, 162, 255, 1));
`;

// login "start here"
export const blueGradient = css`
  background: linear-gradient(0deg, rgba(26, 99, 255, 0.61), rgba(26, 99, 255, 0.61)),
    ${gradientMiddleLayer}, ${gradientBottomLayer};
`;

// beginner challenges
const purpleGradient = css`
  background: linear-gradient(0deg, rgba(119, 101, 255, 0.61), rgba(119, 101, 255, 0.61)),
    ${gradientMiddleLayer}, ${gradientBottomLayer};
`;

// frontend challenges
const greenGradient = css`
  background: linear-gradient(0deg, rgba(26, 255, 110, 0.61), rgba(26, 255, 110, 0.61)),
    ${gradientMiddleLayer}, ${gradientBottomLayer};
`;

// backend challenges

const lightBlueGradient = css`
  background: linear-gradient(0deg, rgba(0, 225, 255, 0.61), rgba(0, 225, 255, 0.61)),
    ${gradientMiddleLayer}, ${gradientBottomLayer};
`;

// final challenge
const neonGradient = css`
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)),
    conic-gradient(
      from -18.95deg at 50% 50%,
      #8000ff 0deg,
      #ffee93 95.4deg,
      #0047ff 212.4deg,
      #ff57c6 266.4deg,
      #6100ff 320.4deg,
      #8000ff 356.4deg,
      #8000ff 360deg
    ),
    ${gradientBottomLayer};
`;

export const variantGradient = {
  center: blueGradient,
  beginner: purpleGradient,
  backend: lightBlueGradient,
  frontend: greenGradient,
  final: neonGradient,
};

export const unlockedColor = '#00FF04';
export const lockedColor = '#FF6200';
